module.exports = __webpack_public_path__ + "static/media/active-bottom-shield.f25bf64f.svg";